import React from 'react';
import Nav from './Nav';
import Posts from './Posts';

const Dashboard = () => {
  return (
    <div>
      <Nav />
      <Posts />
    </div>
  );
};

export default Dashboard;
